<div *ngIf="shouldShowStatement">

  <div class="row mt-3">

    <div class="col-md-12">

      <div class="text-right">
        RFC: <span class="pl-5">{{rfc}}</span>
      </div>

      <h5 class="mt-1 text-center">{{companyName}}</h5>
      <h5 class="mb-4 text-center text-uppercase">estado de cuenta de la caja de ahorro para el retiro</h5>

    </div>

  </div>

  <div class="px-5 border-top"></div>

  <div class="row mt-3">

    <div class="col-md-4">
      <mat-form-field>
        <input matInput placeholder="Nombre:" [value]="displayName" readonly>
      </mat-form-field>
    </div>

    <div class="col-md-4">
      <mat-form-field>
        <input matInput placeholder="Departamento:" [value]="department" readonly>
      </mat-form-field>
    </div>

    <div class="col-md-4">
      <mat-form-field>
        <input matInput placeholder="RFC:" [value]="employeeRFC" readonly>
      </mat-form-field>
    </div>

  </div>

  <div class="row">

    <div class="col-md-4">
      <mat-form-field>
        <input matInput placeholder="Número De Colaborador:" [value]="employeeNumber" readonly>
      </mat-form-field>
    </div>

    <div class="col-md-4">
      <mat-form-field>
        <input matInput placeholder="ID Departamento:" [value]="departmentID" readonly>
      </mat-form-field>
    </div>
  </div>

  <div class="row justify-content-end">
    <div class="col-md-2 col-sm-2 mx-3">
      <mat-form-field>
        <mat-select placeholder="Años Anteriores:" (selectionChange)="selectedPeriodChange($event)"
          [value]="selectedYear">
          <mat-option>Seleccione Un Año</mat-option>
          <mat-option *ngFor="let year of pastYears" [value]="year">
            {{year}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <!-- table  -->

  <div class="row px-3 mt-5">

    <div class="col-md-4 border d-flex align-items-center justify-content-center bg-report-header text-white">
      Concepto
    </div>

    <div class="col-md-4 border-top border-bottom bg-report-header text-white">
      <div class="row border-bottom">
        <div class="col-md-12 d-flex justify-content-center">Aportación del Año {{selectedYear}}</div>
      </div>
      <div class="row">
        <div class="col-md-6 d-flex border-right justify-content-center">Empresa</div>
        <div class="col-md-6 d-flex justify-content-center">Colaborador</div>
      </div>
    </div>

    <div class="col-md-4 border bg-report-header text-white">
      <div class="row border-bottom">
        <div class="col-md-12 d-flex justify-content-center">Total Acumulado</div>
      </div>
      <div class="row">
        <div class="col-md-6 d-flex border-right justify-content-center">Empresa</div>
        <div class="col-md-6 d-flex justify-content-center">Colaborador</div>
      </div>
    </div>

  </div>

  <div class="row px-3 border-bottom">

    <div class="col-md-4 border-left border-right d-flex align-items-center justify-content-center">
      Saldo Años Anteriores
    </div>

    <div class="col-md-4">
      <div class="row">
        <div class="col-md-6 d-flex border-right justify-content-center">&nbsp;</div>
        <div class="col-md-6 d-flex justify-content-center">&nbsp;</div>
      </div>
    </div>

    <div class="col-md-4 border-left border-right">
      <div class="row">
        <div class="col-md-6 d-flex border-right justify-content-center">$ {{totalCompanyPastYears | number: '.2'}}</div>
        <div class="col-md-6 d-flex justify-content-center"> $ {{totalEmployeePastYears | number: '.2'}}</div>
        <!--div class="col-md-6 d-flex border-right justify-content-center">$ {{(totalCompanyPastYears + totalCompanyPastSettlement) | number: '.2'}}</div>
        <div class="col-md-6 d-flex justify-content-center"> $ {{(totalEmployeePastYears + totalEmployeePastSettlement) | number: '.2'}}</div-->
      </div>
    </div>

  </div>

  <div class="row px-3 border-bottom">

    <div
      class="col-md-4 border-left border-right d-flex align-items-center justify-content-center bg-report-header text-white">
      Aportaciones Año {{selectedYear}}
    </div>

    <div class="col-md-4 bg-light">
      <div class="row">
        <div class="col-md-6 d-flex justify-content-center">&nbsp;</div>
        <div class="col-md-6 d-flex justify-content-center">&nbsp;</div>
      </div>
    </div>

    <div class="col-md-4 border-right bg-light">
      <div class="row">
        <div class="col-md-6 d-flex justify-content-center">&nbsp;</div>
        <div class="col-md-6 d-flex justify-content-center">&nbsp;</div>
      </div>
    </div>

  </div>

  <div class="row px-3 border-bottom" *ngFor="let item of payrollContributionArray">

    <div class="col-md-4 border-left border-right d-flex align-items-center justify-content-center">
      {{item.month}}
    </div>

    <div class="col-md-4">
      <div class="row">
        <div class="col-md-6 d-flex border-right justify-content-center">$ {{item.companyAmount | number: '.2'}}</div>
        <div class="col-md-6 d-flex justify-content-center">$ {{item.employeeAmount | number: '.2'}}</div>
      </div>
    </div>

    <div class="col-md-4 border-left border-right bg-light">
      &nbsp;
    </div>

  </div>

  <div class="row px-3 border-bottom">

    <div class="col-md-4 border-left border-right text-right">
      Total acumulado año vigente {{selectedYear}}
    </div>

    <div class="col-md-4">
      <div class="row">
        <div class="col-md-6 d-flex border-right justify-content-center">$ {{currentTotalCompany | number: '.2'}}</div>
        <div class="col-md-6 d-flex justify-content-center">$ {{currentTotalEmployee | number: '.2'}}</div>
      </div>
    </div>

    <div class="col-md-4 border-left border-right bg-light">
      &nbsp;
    </div>

  </div>
  
  <!--div *ngIf="totalEmployeeSettlement != 0" class="row px-3 border-bottom" style="background-color: #d9ebfc;">
    <div class="col-md-4 border-left border-right text-right">
      Total Liquidación
    </div>

    <div class="col-md-4 d-flex justify-content-center">&nbsp;</div>

    <div class="col-md-4 border-left border-right">
      <div class="row">
        <div class="col-md-6 d-flex border-right justify-content-center">$ {{totalEmployeeSettlement | number: '.2'}}</div>
        <div class="col-md-6 d-flex justify-content-center">$ {{totalEmployeeSettlement | number: '.2'}}</div>
      </div>
    </div>

  </div-->

  <div class="row px-3 border-bottom">

    <div class="col-md-4 border-left border-right text-right bg-report-header text-white">
      Total Aportaciones Acumuladas
    </div>

    <div class="col-md-4 d-flex justify-content-center bg-report-header text-white">&nbsp;</div>

    <div class="col-md-4 border-left border-right bg-report-header text-white">
      <div class="row">
        <div class="col-md-6 d-flex border-right justify-content-center">$ {{totalCompany | number: '.2'}}</div>
        <div class="col-md-6 d-flex justify-content-center">$ {{totalEmployee | number: '.2'}}</div>
      </div>
    </div>

  </div>

  <div  class="row px-3 mb-5">
    <div class="col-md-5">
      <div  class="row" *ngFor="let item of totalCurrent">
        <div
        class="col-md-6 d-flex border-top border-left border-bottom border-right justify-content-left bg-report-header text-white">
         {{item.text}}</div>
       <div class="col-md-5 d-flex border-top border-left border-bottom border-right justify-content-center">{{item.total && item.total > 0 ? '$ ' +
         (item.total | number: '.2-2') : '-'}}</div>
         <div *ngIf="item.note" class="tooltip-main" data-toggle="tooltip" data-placement="top" title="{{item.note}}">
          <span class="tooltip-qm">?</span>
        </div>
      </div>
    </div>
    <div class="col-md-2 d-flex justify-content-center">&nbsp;</div>
    <div class="col-md-5 border-top">
      <div  class="row" *ngFor="let item of totals">
        <div
        class="col-md-6 d-flex border-left border-bottom border-right justify-content-left bg-report-header text-white">
         {{item.text}}</div>
       <div class="col-md-6 d-flex border-left border-bottom border-right justify-content-center">{{item.total && item.total > 0 ? '$ ' +
         (item.total | number: '.2-2') : '-'}}</div>

      </div>
      
    </div>
</div>
<div  class="row px-3 mb-5">
  <div class="col-md-5">
    <div  class="row" *ngFor="let item of totalPrevious">
      <div
      class="col-md-6 d-flex border-top border-left border-bottom border-right justify-content-left bg-report-header text-white">
       {{item.text}}</div>
     <div class="col-md-5 d-flex border-top border-left border-bottom border-right justify-content-center">{{item.total ? '$ ' +
       (item.total | number: '.2-2') : '-'}}</div>
       <div *ngIf="item.note" class="tooltip-main" data-toggle="tooltip" data-placement="top" title="{{item.note}}">
        <span class="tooltip-qm">?</span>
      </div>

    </div>
  </div>
  <div class="col-md-3 d-flex justify-content-center">&nbsp;</div>
  <div class="col-md-4">
    <div  class="row mt-4">
      <div class="col-md-12" *ngIf="downloadURLLink; else noLink">
        <a class="btn btn-primary btn-block text-white" [href]="downloadURLLink" target="_blank">Ver Reglamento</a>
      </div>
    
      <ng-template #noLink>
        <div class="col-md-12">
          <div class="btn btn-primary btn-block text-white">No se ha definido un reglamento</div>
        </div>
      </ng-template>


    </div>
    
  </div>
</div>

<div class="row px-3 border-bottom mb-5 ">
  <div class="col-md-12 bg-report-header text-white d-flex align-items-center justify-content-end">
    <span style="font-size:10pt;">Nota: Los rendimientos están actualizados al dia de hoy y pueden subir o bajar
      diariamente dependiendo de condiciones no sujetas a nuestro control.</span>
  </div>
</div>

</div>

<div *ngIf="!shouldShowStatement">

  <div class="row mt-3">
    <div class="col-md-12">

      <h5 class="mt-1 text-center text-uppercase">Estado de cuenta de la caja de ahorro para el retiro</h5>

    </div>
  </div>

  <div class="px-5 border-top"></div>

  <div class="row mt-3">

    <div class="col-md-4">
      <mat-form-field>
        <input matInput placeholder="Nombre:" [value]="displayName" readonly>
      </mat-form-field>
    </div>

    <div class="col-md-4">
      <mat-form-field>
        <input matInput placeholder="Departamento:" [value]="department">
      </mat-form-field>
    </div>

    <div class="col-md-4">
      <mat-form-field>
        <input matInput placeholder="RFC:" [value]="employeeRFC">
      </mat-form-field>
    </div>

  </div>

  <div class="row">

    <div class="col-md-4">
      <mat-form-field>
        <input matInput placeholder="Número De Colaborador:" [value]="employeeNumber" readonly>
      </mat-form-field>
    </div>

    <div class="col-md-4">
      <mat-form-field>
        <input matInput placeholder="ID Departamento:" [value]="departmentID" readonly>
      </mat-form-field>
    </div>

  </div>

  <div class="px-5 border-top"></div>

  <div class="row mt-4">
    <div class="col-md-12 text-center noActions">
      <mat-icon aria-hidden="true">search</mat-icon>
      <h5>No existen datos en los acumulados del colaborador para este ciclo</h5>
    </div>
  </div>

</div>
